import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Button } from '../Button';
import { useTheme } from '@mui/material/styles';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
export function CloseButton(props) {
  var _props$height = props.height,
    height = _props$height === void 0 ? '20px' : _props$height,
    intent = props.intent,
    onClose = props.onClose,
    _props$size = props.size,
    size = _props$size === void 0 ? 20 : _props$size,
    sx = props.sx,
    _props$width = props.width,
    width = _props$width === void 0 ? '20px' : _props$width;
  var theme = useTheme();
  var getIconColor = function getIconColor() {
    switch (intent) {
      case 'warning':
      case 'neutral':
        return {
          color: "".concat(theme.palette.gray[600], "!important")
        };
    }
  };
  return /*#__PURE__*/_jsx(Button, {
    onClick: function onClick(e) {
      onClose && onClose(e, 'closeButtonClick');
    },
    sx: _extends({
      '.MuiSvgIcon-root': _extends({}, getIconColor()),
      height: height,
      width: width
    }, sx),
    variant: "tertiary-gray",
    "data-element": "Button",
    "data-component": "CloseButton",
    "data-source-file": "CloseButton.tsx",
    children: /*#__PURE__*/_jsx(Icon, {
      iconId: "XClose",
      size: size,
      "data-element": "Icon",
      "data-source-file": "CloseButton.tsx"
    })
  });
}